module.exports = __webpack_public_path__ + "img/box_green_small.5fa3bbd7.png";